// removed by extract-text-webpack-plugin
module.exports = {"selectWrapper":"_1KaE4EMNBaVhNTFsrjkLLW","selectLabel":"_3SedHDEezj94HBBxA-B4C9","selectBase":"_2R-mlk_ljSkfEXNWFHAlUN"};


//////////////////
// WEBPACK FOOTER
// ./src/react/ui/features/DropDown/DropDown.styl
// module id = 733
// module chunks = 0